import React from "react";
import Base from "../../components/BaseTemplate";
import toast from "react-hot-toast";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";


function ResetPassword() {
    const token = useParams();
    console.log(token);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [validated, setValidated] = useState(false);
    const navigate = useNavigate();

    async function resetPassword(e) {
        e.preventDefault();
        console.log("Sending password reset request");
        await axios({
            method: "POST",
            url: "/auth/reset_password",
            data: {
                password: password,
                token: token.token,
            },
        })
            .then((res) => {
                console.log(res);
                toast.success(res.data.msg);
                setTimeout(() => {
                    navigate("/login");
                }, 2000);
            })
            .catch((err) => {
                console.log(err);
                toast.error(err.msg);
            });
    }

    return (
        <Base>
            <Row className="justify-content-md-center">
                <Col lg="5">
                    <Container fluid className="page-content">
                        <Card className="text-center">
                            <Card.Header>
                                <h1>Reset Password</h1>
                            </Card.Header>
                            <Card.Body>
                                <Form noValidate validated={validated} onSubmit={resetPassword}>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Password</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="password"
                                                    placeholder="Enter password"
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Confirm Password</Form.Label>
                                                <Form.Control
                                                    required
                                                    type="password"
                                                    placeholder="Confirm password"
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Button variant="primary" type="submit">
                                                Reset Password
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Container>
                </Col>
            </Row>
        </Base>
    );
}
export default ResetPassword;